@if (state.pagination && state.pagination.totalPages > 1) {
  <div class="small:gap-4 mt-6 flex items-center justify-center gap-2 py-6">
    <dojo-button
      [fill]="'outline'"
      [customColor]="'sky'"
      [disabled]="state.pagination.isPreviousDisabled"
      (click)="goToPreviousPage()"
      [size]="'m'"
      class="small:h-10 small:w-10 h-8 w-8"
    >
      <dojo-icon [icon]="'angle-left'" [size]="16" />
    </dojo-button>

    <div class="small:gap-2 flex items-center gap-1">
      @for (item of state.pagination.pageNumbers; track $index) {
        @if (item === 'ellipsis') {
          <span class="small:h-10 small:w-10 flex h-8 w-8 items-center justify-center text-gray-400">···</span>
        } @else if (typeof item === 'number') {
          <dojo-button
            [fill]="'clear'"
            [customColor]="'sky'"
            [class.active]="item === state.pagination.page"
            (click)="goToPage(item)"
            [size]="'m'"
            class="page-number-button small:h-10 small:w-10 h-8 w-8"
          >
            <span>{{ item }}</span>
          </dojo-button>
        }
      }
    </div>

    <dojo-button
      [fill]="'outline'"
      [disabled]="state.pagination.isNextDisabled"
      (click)="goToNextPage()"
      [size]="'m'"
      class="small:h-10 small:w-10 h-8 w-8"
    >
      <dojo-icon [icon]="'angle-right'" [size]="16" />
    </dojo-button>
  </div>
}
